<section class="settings-content">
  <div class="settings-content__section">
    <h4 class="settings-content__section-title">{{ jsonPath + 'section-title' | translate }}</h4>

    <div class="settings-content__table-wrapper">
      <table class="settings-content__table">
        <thead>
          <tr class="settings-content__header-row">
            <th class="settings-content__header-cell settings-content__header-cell--page">
              {{ jsonPath + 'section-title' | translate }}
            </th>
            <th class="settings-content__header-cell settings-content__header-cell--visibility">
              {{ jsonPath + 'visibility' | translate }}
            </th>
            <th class="settings-content__header-cell settings-content__header-cell--date">
              {{ jsonPath + 'lastUpdate' | translate }}
            </th>
            <th class="settings-content__header-cell settings-content__header-cell--updated-by">
              {{ jsonPath + 'updatedBy' | translate }}
            </th>
            <th class="settings-content__header-cell settings-content__header-cell--actions">
              {{ jsonPath + 'actions' | translate }}
            </th>
          </tr>
        </thead>

        <tbody>
          @for (row of mainPageContents(); track row.id) {
            <tr class="settings-content__row">
              <td class="settings-content__cell settings-content__cell--page">
                {{ 'shop-settings.content.table.section-type.' + row.sectionType | translate }}
              </td>

              <td class="settings-content__cell settings-content__cell--visibility">
                {{ row.isVisible ? 'Yes' : 'No' }}
              </td>

              <td class="settings-content__cell settings-content__cell--date">
                {{ row.lastUpdated ? (row.lastUpdated | date: 'dd.MM.yyyy') : '-' }}
              </td>

              <td class="settings-content__cell settings-content__cell--updated-by">
                {{ row.updatedBy || '-' }}
              </td>

              <td class="settings-content__cell settings-content__cell--actions">
                <button
                  type="button"
                  class="settings-content__action-btn"
                  [matMenuTriggerFor]="mainPageMenu"
                >
                  <app-icon
                    class="settings-content__ellipsis-vertical-icon"
                    [icon]="iconNames.ELLIPSIS_VERTICAL"
                  />
                </button>

                <mat-menu #mainPageMenu="matMenu">
                  <button
                    mat-menu-item
                    class="settings-content__menu-item"
                    (click)="openViewContent(row)"
                  >
                    <app-icon class="settings-content__menu-icon" [icon]="iconNames.VIEW_DETAILS" />
                    <span>
                      {{ 'shop-settings.content.table.action-buttons.view-content' | translate }}
                    </span>
                  </button>

                  <button
                    mat-menu-item
                    class="settings-content__menu-item"
                    (click)="openEditContent(row)"
                  >
                    <app-icon class="settings-content__menu-icon" [icon]="iconNames.EDIT_PENCIL" />
                    <span>
                      {{ 'shop-settings.content.table.action-buttons.edit-content' | translate }}
                    </span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="settings-content__section">
    <h4 class="settings-content__section-title">{{ jsonPath + 'static-title' | translate }}</h4>

    <div class="settings-content__table-wrapper">
      <table class="settings-content__table">
        <thead>
          <tr class="settings-content__header-row">
            <th class="settings-content__header-cell settings-content__header-cell--page">
              {{ jsonPath + 'page' | translate }}
            </th>
            <th class="settings-content__header-cell settings-content__header-cell--visibility">
              {{ jsonPath + 'visibility' | translate }}
            </th>
            <th class="settings-content__header-cell settings-content__header-cell--date">
              {{ jsonPath + 'lastUpdate' | translate }}
            </th>
            <th class="settings-content__header-cell settings-content__header-cell--updated-by">
              {{ jsonPath + 'updatedBy' | translate }}
            </th>
            <th class="settings-content__header-cell settings-content__header-cell--content">
              {{ jsonPath + 'content' | translate }}
            </th>
            <th class="settings-content__header-cell settings-content__header-cell--actions">
              {{ jsonPath + 'actions' | translate }}
            </th>
          </tr>
        </thead>

        <tbody>
          @for (content of staticPageContents(); track content.id) {
            <tr class="settings-content__row">
              <td class="settings-content__cell settings-content__cell--page">
                {{ 'shop-settings.content.table.section-type.' + content.sectionType | translate }}
              </td>

              <td class="settings-content__cell settings-content__cell--visibility">
                {{ content.isVisible ? 'Yes' : 'No' }}
              </td>

              <td class="settings-content__cell settings-content__cell--date">
                {{ content.lastUpdated | date: 'dd.MM.yyyy' }}
              </td>

              <td class="settings-content__cell settings-content__cell--updated-by">
                {{ content.updatedBy }}
              </td>

              <td class="settings-content__cell settings-content__cell--content">
                <span
                  class="settings-content__content-preview"
                  [title]="getContentPreview(content.content)"
                >
                  {{ getContentPreview(content.content) }}
                </span>
              </td>

              <td class="settings-content__cell settings-content__cell--actions">
                <button
                  type="button"
                  class="settings-content__action-btn"
                  [matMenuTriggerFor]="staticPageMenu"
                >
                  <app-icon
                    class="settings-content__ellipsis-vertical-icon"
                    [icon]="iconNames.ELLIPSIS_VERTICAL"
                  />
                </button>

                <mat-menu #staticPageMenu="matMenu">
                  <button
                    mat-menu-item
                    class="settings-content__menu-item"
                    (click)="openViewContent(content)"
                  >
                    <app-icon class="settings-content__menu-icon" [icon]="iconNames.VIEW_DETAILS" />
                    <span>
                      {{ 'shop-settings.content.table.action-buttons.view-content' | translate }}
                    </span>
                  </button>
                  <button
                    mat-menu-item
                    class="settings-content__menu-item"
                    (click)="openEditCategoriesModal(content)"
                  >
                    <app-icon class="settings-content__menu-icon" [icon]="iconNames.EDIT_PENCIL" />
                    <span>
                      {{ 'shop-settings.content.table.action-buttons.edit-categories' | translate }}
                    </span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</section>
